import Input from '../Input'

export default class TextInput extends Input {}
